import { gql } from "@apollo/client";

export const GET_STATS = gql`
  query GetStats {
    stats {
      timestamp
      
      # Bookings
      bookingsLast7Days
      bookingsLast7DaysYoy
      bookingsLast30Days
      bookingsLast30DaysYoy
      bookingsMonthToDate
      bookingsMonthToDateLastYear
      bookingsMonthLastYearTotal
      
      # Quotes Sent
      quotesSentLast7Days
      quotesSentLast7DaysYoy
      quotesSentLast30Days
      quotesSentLast30DaysYoy
      quotesSentMonthToDate
      quotesSentMonthToDateLastYear
      quotesSentMonthLastYearTotal
      
      # Closed Bookings
      closedBookingsLast7Days
      closedBookingsLast7DaysYoy
      closedBookingsLast30Days
      closedBookingsLast30DaysYoy
      closedBookingsMonthToDate
      closedBookingsMonthToDateLastYear
      closedBookingsMonthLastYearTotal
      
      # Quote Rate
      quoteRateLast7Days
      quoteRateLast7DaysYoy
      quoteRateLast30Days
      quoteRateLast30DaysYoy
      quoteRateMonthToDate
      quoteRateMonthToDateLastYear
      quoteRateMonthLastYearTotal
      
      # Close Rate
      closeRateLast7Days
      closeRateLast7DaysYoy
      closeRateLast30Days
      closeRateLast30DaysYoy
      closeRateMonthToDate
      closeRateMonthToDateLastYear
      closeRateMonthLastYearTotal
    }
  }
`;